import { BrowserModule, Title } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { CoreModule } from '@app/core/core.module';
import { CookieModule } from 'ngx-cookie';
import { BrowserTransferStateModule } from '@modules/transfer-state/browser-transfer-state.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { HttpClientModule } from '@angular/common/http';
import { RuntimeEnvironmentService } from '@app/core/runtime-environment.service';
import { WindowTokenModule } from '@modules/window-token/window-token.module';
import { RavenErrorHandlerService } from '@app/core/raven/raven-error-handler.service';
import { RavenInstallService } from '@app/core/raven/raven-install.service';
import { AgmCoreModule } from '@agm/core';
import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import localeRuExtra from '@angular/common/locales/extra/ru';
import { Angulartics2Module } from 'angulartics2';
import { Angulartics2GoogleTagManager } from 'angulartics2/gtm';
import { InlineSVGModule } from 'ng-inline-svg';
import { SharedModule } from '@app/shared/shared.module';
import { StickyModule } from 'ng2-sticky-kit';
import { AppRoutingModule } from '@app/app-routing.module';
import { AccountsModule } from '@app/accounts/accounts.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule, BsDropdownModule } from 'ngx-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LocalStorageModule } from '@modules/local-storage/local-storage.module';
import { NgxMasonryModule } from 'ngx-masonry';
import { NgxMaskModule } from 'ngx-mask';

registerLocaleData(localeRu, localeRuExtra);

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    // Add .withServerTransition() to support Universal rendering.
    BrowserModule.withServerTransition({appId: 'app-frontend'}),
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    CookieModule.forRoot(),
    AgmCoreModule.forRoot(),
    Angulartics2Module.forRoot([Angulartics2GoogleTagManager]),
    BrowserTransferStateModule,
    InfiniteScrollModule,
    HttpClientModule,
    NgSelectModule,
    NgxMasonryModule,
    NgxMaskModule.forRoot(),
    WindowTokenModule,
    InlineSVGModule,
    StickyModule,
    LocalStorageModule.forRoot(),

    AppRoutingModule,
    AccountsModule,
    CoreModule,
    SharedModule.forRoot(),
  ],
  providers: [
    Title,
    RuntimeEnvironmentService,
    RavenInstallService,
    { provide: ErrorHandler, useClass: RavenErrorHandlerService },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts